import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { FaThreads, FaXTwitter } from "react-icons/fa6";
import { AiOutlineDownload, AiOutlineUserAdd, AiOutlineTrophy } from "react-icons/ai";
import { PhoneCall, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#020617] text-gray-300 py-14 mt-auto">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10">

        {/* CONTACT */}
        <div className="space-y-4">
          <h4 className="font-bold text-white text-xl mb-2">Contact</h4>
          <p className="flex items-center gap-2">
            <MapPin size={18} className="text-purple-400" />  
           No.1, Barathi Nagar, Sipcot, Ranipet (Opposite to Collector Office)  Tamil Nadu.
          </p>
          <p className="flex items-center gap-2">
            <Mail size={18} className="text-pink-400" />  
           ranipetdistrictchess2021@gmail.com
          </p>
          <p className="flex items-center gap-2">
            <PhoneCall size={18} className="text-blue-400" />  
            +91 9698939993
          </p>
          <p className="text-sm text-gray-400">
            Open Mon-Sat: 9AM - 6PM
          </p>
        </div>

        {/* SOCIAL MEDIA */}
        <div className="space-y-4 flex flex-col md:items-center items-start">
          <h4 className="font-bold text-white text-xl mb-2">Follow Us</h4>
          <div className="flex md:justify-center justify-start gap-4">
            {/* Instagram */}
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-slate-800 hover:text-[#E1306C] transition-all duration-300"
              aria-label="Instagram"
            >
              <FaInstagram size={22} />
            </a>

            {/* Facebook */}
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-slate-800 hover:text-[#1877F2] transition-all duration-300"
              aria-label="Facebook"
            >
              <FaFacebookF size={22} />
            </a>

            {/* Threads */}
            <a
              href="https://threads.net/@yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-slate-800 hover:text-white transition-all duration-300"
              aria-label="Threads"
            >
              <FaThreads size={22} />
            </a>

            {/* X Twitter */}
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-slate-800 hover:text-[#1DA1F2] transition-all duration-300"
              aria-label="X Twitter"
            >
              <FaXTwitter size={22} />
            </a>
          </div>
        </div>

        {/* USEFUL LINKS */}
        <div className="space-y-4 md:text-right text-left md:justify-self-end">
          <h4 className="font-bold text-white text-xl mb-2">Useful Links</h4>
          <ul className="space-y-2">
            <li className="hover:text-purple-400 transition-colors cursor-pointer">
              <a href="/bid-form.pdf" download className="flex md:justify-end justify-start items-center gap-2">
                <AiOutlineDownload size={18} /> Downloads
              </a>
            </li>
            <li className="hover:text-purple-400 transition-colors cursor-pointer">
              <Link to="/players/register" className="flex md:justify-end justify-start items-center gap-2">
                <AiOutlineUserAdd size={18} /> Register
              </Link>
            </li>
            <li className="hover:text-purple-400 transition-colors cursor-pointer">
              <Link to="/news" className="flex md:justify-end justify-start items-center gap-2">
                <AiOutlineTrophy size={18} /> News
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* DIVIDER */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Ranipet District Chess Academy. All rights reserved.
      </div>
    </footer>
  );
}
